<template>

  <div  class="mb-3">

    <b-form-group
      :class="title_position"
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >

      <b-form-input
        :class="{ 'is-invalid': v.$error }"
        :min="min" 
        :max="max"
        v-model="InputName"
        id="date"
        @input="$emit('input', InputName)"
        type="date"
        :disabled="FormDataType.Disabled"
      ></b-form-input>
      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{  $t("ValidationMessage.required") }}</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>

import moment from "moment";
export default {
  data() {
 
    return {
      InputName: "",

    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    Value: String,
    title_position: String,
    min: String,
    max: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.$options.filters.formatDate(this.Value);
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>
